import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { TermService, TagDto } from '@/api';
import ModalDialog from '@/components/modal-dialog/Modal-Dialog.vue';
import type { VForm } from 'vuetify/lib';
import { Inputs } from '@/@types/types';
import i18n from '@/i18n';
import SRichTextEditor from '@/components/SRichTextEditor.vue';

interface Props {
  selectedTerm?: TagDto | null;
}

type Emits = {
  (event: 'onValidate'): void,
  // Compatibility events
  (event: 'on-create'): void,
  (event: 'on-edit'): void,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Business-Glossary-Terms-Edit',
  props: {
  selectedTerm: null
},
  emits: ["onValidate", "on-create", "on-edit"],
  setup(__props, { expose, emit }) {

const props = __props;



const modalDialogRef = _ref<InstanceType<typeof ModalDialog> | null>(null);
const businessGlossaryForm = _ref<InstanceType<typeof VForm>| null>(null);
const nameCounter = _ref(Inputs.INPUT_VERY_LOW_CHARS);
const isValid = _ref(false);

let editSingle = _ref(false);
let term = _ref<TagDto>({
  id: '',
  name: '',
  description: '',
  type: TagDto.type.TERM,
});

const nameRules = _computed(() => [
  (value: string) => !!value || i18n.t('glossary.term_required'),
  (value: string) => (value && value.length <= nameCounter.value) || i18n.t('glossary.max_character', { count: nameCounter.value }),
]);

const modifyExisting = _computed(() => !!props.selectedTerm || editSingle.value);

const title = _computed(() => (modifyExisting.value ? i18n.t('glossary.edit_existent', { term: term.value.name }) : i18n.t('glossary.add_term')));

const init = () => {
  editSingle.value = false;
  term.value = {
    id: '',
    name: '',
    description: '',
    type: TagDto.type.TERM,
  };
  if (businessGlossaryForm.value) {
    (businessGlossaryForm.value as any).resetValidation();
  }
};

const addNewTerm = () => {
  init();
  modalDialogRef.value?.openDialog();
};

const editTerm = async () => {
  if (props.selectedTerm) {
    term.value = await TermService.getTermById({ id: props.selectedTerm.id });
    modalDialogRef.value?.openDialog();
  }
};

const editSingleTerm = async (editedTerm: TagDto) => {
  editSingle.value = true;
  term.value = await TermService.getTermById({ id: editedTerm.id });
  modalDialogRef.value?.openDialog();
};

const close = () => modalDialogRef.value?.closeDialog();

const validate = async () => {
  if (modifyExisting.value) {
    await TermService.updateTerm({ id: term.value.id, requestBody: term.value });
    emit('on-edit');
  } else {
    await TermService.createTerm({ requestBody: term.value });
    emit('on-create');
  }
  emit('onValidate');
  close();
};

expose({ addNewTerm, editTerm, editSingleTerm });

return { __sfc: true,props, emit, modalDialogRef, businessGlossaryForm, nameCounter, isValid, editSingle, term, nameRules, modifyExisting, title, init, addNewTerm, editTerm, editSingleTerm, close, validate, _ref, _computed, TermService, TagDto, ModalDialog, Inputs, i18n, SRichTextEditor }
}

})